// Émission des documents officiels — un numéro FAC- n'est attribué QUE sur
// action explicite. Ouvrir ou imprimer un aperçu n'émet rien.
const API = `${process.env.REACT_APP_BACKEND_URL}/api/emission`;

const entetes = (utilisateur) => ({
  'Content-Type': 'application/json',
  // `useAuth().user` expose `name` : on accepte les deux formes pour rester sûr.
  // En-tête HTTP = latin-1 uniquement : on encode pour préserver les accents.
  'X-Utilisateur': encodeURIComponent(utilisateur?.name ?? utilisateur?.nom ?? 'inconnu'),
  'X-Utilisateur-Role': utilisateur?.role ?? '',
});

const json = async (r) => {
  const data = await r.json().catch(() => null);
  if (!r.ok) return { error: data?.detail ?? `Erreur ${r.status}`, data: null };
  return { error: null, data };
};

export const ROLES_EMISSION = ['Administrateur', 'Comptable'];
export const peutEmettre = (utilisateur) => ROLES_EMISSION.includes(utilisateur?.role);

export const fetchConfigSouche = async () => (await json(await fetch(`${API}/config`))).data;

export const fetchEmission = async (operationType, operationId) => {
  const q = new URLSearchParams({ operation_type: operationType, operation_id: String(operationId) });
  const { data } = await json(await fetch(`${API}/facture?${q}`));
  return data?.numero ? data : null;
};

export const fetchEmissions = async () => (await json(await fetch(`${API}/factures`))).data ?? [];

export const emettreFacture = (payload, utilisateur) =>
  fetch(`${API}/facture`, { method: 'POST', headers: entetes(utilisateur), body: JSON.stringify(payload) }).then(json);

export const emettreAvoir = (factureNumero, motif, utilisateur) =>
  fetch(`${API}/avoir`, {
    method: 'POST',
    headers: entetes(utilisateur),
    body: JSON.stringify({ facture_numero: factureNumero, motif }),
  }).then(json);

export const urlPdfOfficiel = (numero) => `${API}/document/${numero}/pdf`;

// Convertit les lignes d'un aperçu PrintDoc ([libellé, valeur]) en photographie figée.
export const lignesFigees = (paires) =>
  (paires ?? [])
    .filter((p) => Array.isArray(p) && p[0])
    .map(([designation, valeur]) => ({ designation: String(designation), valeur: valeur == null ? '' : String(valeur) }));
